import { Box, BoxProps, Text } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { errorPageContent } from "./error-page-content";

export interface ErrorPageProps
  extends PropsWithChildren<
    BoxProps & {
      statusCode: keyof typeof errorPageContent;
    }
  > {
  message?: null | string;
}
export function ErrorPage({
  statusCode,
  children,
  message,
  ...props
}: ErrorPageProps) {
  const content = errorPageContent[statusCode];
  return (
    <Box as="section">
      <Box
        maxW="3xl"
        mx="auto"
        px={{ base: "6", lg: "8" }}
        py={{ base: "16", sm: "20" }}
        textAlign="center"
        {...props}
      >
        <Box>
          <Text fontWeight="semibold" fontSize="xl" color={"green.600"}>
            {content.header}
          </Text>
          <Text
            as="h1"
            fontFamily="numeric"
            letterSpacing="tighter"
            fontSize={{
              base: "7.5em",
              md: "10em",
              lg: "15em",
            }}
            fontWeight="black"
            color="blue.600"
          >
            {statusCode}
          </Text>
        </Box>
        <Text fontSize="lg" maxW="xl" mx="auto" pb="6">
          {message ? message : content["message"]}
        </Text>
        {children}
      </Box>
    </Box>
  );
}
